import { persistedReducer } from '@/store/reducer';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

export { type RootState } from '@/store/reducer';

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: {
    name: 'Webshop',
  },
});

const persistor = persistStore(store);

export { persistor, store };
